import {
    loginByPassword,
    getInfo
} from "@/api/login";
import {
    getToken,
    normalizeToken,
    setToken,
    removeToken
} from "@/utils/auth";

const user = {
    state: {
        token: getToken(),
        userInfo: {},
        showSetPasswordModal: false,
        setPasswordModalEmail: '',

        // menuIndex: 1,
        // isMobile: false
    },

    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token;
        },
        SET_USER: (state, userInfo) => {
            state.userInfo = userInfo;
        },
        SET_SHOW_SET_PASSWORD_MODAL: (state, show) => {
            state.showSetPasswordModal = show;
        },
        SET_SET_PASSWORD_MODAL_EMAIL: (state, email) => {
            state.setPasswordModalEmail = email;
        },
        // SET_AVATAR: (state, avatar) => {
        //     state.avatar = avatar;
        // },

    },

    actions: {
        async loginWithGoogle({ commit }, credential) {
            try {
                // 这里应添加后端token验证逻辑
                const userData = parseJwt(credential);
                console.error(userData);
                commit('SET_USER', {
                    user: userData,
                    token: credential
                });
            } catch (error) {
                console.error('Login failed:', error);
                throw error;
            }
        },
        ApplyLoginSession({
            commit,
            dispatch
        }, token) {
            const normalizedToken = normalizeToken(token);
            setToken(normalizedToken);
            commit("SET_TOKEN", normalizedToken);
            return dispatch("GetInfo").then(() => normalizedToken);
        },
        // 登录
        Login({
            commit
        }, userInfo) {
            // const username = userInfo.username.trim();
            // const password = userInfo.password;
            // const code = userInfo.code;
            // const uuid = userInfo.uuid;
            return new Promise((resolve, reject) => {
                loginByPassword({
                        ...userInfo
                    })
                    .then((res) => {
                        // res = res.data;
                        setToken(res.data);
                        commit("SET_TOKEN", res.data);
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        // 获取用户信息
        GetInfo({
            commit,
            dispatch
        }) {
            return new Promise((resolve, reject) => {
                getInfo()
                    .then(async(res) => {
                        commit("SET_USER", res.data);

                        // 检查是否需要显示设置密码弹窗
                        if (res.data && res.data.hasPassword === false) {
                            // 触发显示设置密码弹窗的事件
                            dispatch('showSetPasswordModal', {
                                email: res.data.email
                            });
                        }

                        // 登录后按IP初始化地区上下文，并覆盖前端语言
                        await dispatch('InitRegionContext', true);

                        resolve(res);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        // 退出系统
        LogOut({
            commit,
            state
        }) {
            return new Promise((resolve, reject) => {
                logout(state.token)
                    .then(() => {
                        commit("SET_TOKEN", "");

                        removeToken();
                        resolve();
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },

        // 前端 登出
        FedLogOut({
            commit
        }) {
            return new Promise((resolve) => {
                commit("SET_TOKEN", "");
                commit("SET_USER", {});
                removeToken();
                commit('RESET_REGION_CONTEXT');
                resolve();
            });
        },

        // 显示设置密码弹窗
        showSetPasswordModal({
            commit
        }, {
            email
        }) {
            commit("SET_SET_PASSWORD_MODAL_EMAIL", email);
            commit("SET_SHOW_SET_PASSWORD_MODAL", true);
        },

        // 隐藏设置密码弹窗
        hideSetPasswordModal({
            commit
        }) {
            commit("SET_SHOW_SET_PASSWORD_MODAL", false);
            commit("SET_SET_PASSWORD_MODAL_EMAIL", '');
        },

    },
};

function parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(base64));
}

export default user;
